<template>
  <v-dialog v-model="dialog" max-width="450" persistent>
    <v-card>
      <v-card-title class="font-weight-bold">Alterar descrição</v-card-title>

      <v-card-text>
        <carregando-padrao v-if="cargas.carregando"></carregando-padrao>
        <v-form ref="form" v-else>
          <v-text-field
            label="Descrição"
            v-model="nova_descricao"
            autofocus
            :rules="[
              (v) => v.trim().length > 3 || 'Informe a descrição da carga',
            ]"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          rounded
          color="success"
          :loading="alterando"
          @click="alterarDescricao()"
          >Confirmar</v-btn
        >
        <v-btn
          text
          rounded
          color="secondary"
          @click="dialog = false"
          :disabled="alterando"
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import CarregandoPadrao from "../tela/CarregandoPadrao.vue";
export default {
  components: { CarregandoPadrao },
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      } else {
        this.setDescricao();
      }
    },
    [`cargas.dados`]: function (value) {
      if (value) {
        this.setDescricao();
      }
    },
  },
  computed: mapState("formacaoCarga", ["cargaSelec", "cargas"]),
  data: () => ({
    dialog: false,
    nova_descricao: "",
    alterando: false,
  }),
  methods: {
    ...mapMutations("formacaoCarga", ["setDescricao", "setCarga"]),
    setDescricao() {
      if (this.cargas.dados) {
        this.setCarga(
          this.cargas.dados.cargas.find((c) => c.id == this.$route.params.id)
        );
        this.nova_descricao = this.cargaSelec.descricao;
      }
    },
    async alterarDescricao() {
      if (this.$refs.form.validate()) {
        this.alterando = true;
        await axios
          .put(
            "/nutricao-animal/formacao-carga/cargas",
            {
              descricao: this.nova_descricao,
            },
            {
              params: {
                id: this.$route.params.id,
                funcao: "ALTERAR-DESCRICAO",
              },
            }
          )
          .then((res) => {
            if (res.data.success) {
              this.cargaSelec.descricao = this.nova_descricao;
              this.$toasted.success(res.data.msg);
              this.dialog = false;
            } else {
              this.$toasted.error(res.data.msg);
            }
          })
          .catch((e) => this.$toasted.error(e))
          .finally(() => (this.alterando = false));
      }
    },
  },
  mounted() {
    this.dialog = true;
  },
};
</script>

<style>
</style>